export const DocumentEventType = {
    DOWNLOAD: 'download',
    VIEWED: 'viewed'
};
